export default __webpack_public_path__ + "static/media/No.5-2.bd50348e.jpg";